import {Helmet} from "react-helmet-async";
import {useMemo} from "react";
import {useHomeCard} from "../store/home";
import HomeCard from "../cards/Home/HomeCard";

const Showreels = () => {
    const data = useHomeCard((store) => store.data)
    const cards = useMemo(() => {
        return (
            data.map((item) => <HomeCard key={item.id} props={item}/>)
        )
    }, [data])

    return (
        <main className="home">
            <Helmet>
                <title>Showreels - The Kroot</title>
                <meta content="The Kroot Showreels" property="og:title"/>
                <meta content="The Kroot Showreels" property="twitter:title"/>
                <meta name="description"
                      content="The Kroot showreels Character Animation, Traditional Animation,
          Beauty and other VFX services for tv show , music videos and commercial."
                />
                <meta
                    name="keywords"
                    content="The Kroot showreels VFX, Animation, TV shows, Music videos, Commercials, Character Animation, Traditional Animation"
                />
                <meta property="og:image" content="https://www.thekroot.com/logo512.png"/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content="https://www.thekroot.com/"/>
                <meta name="twitter:image" content="https://www.thekroot.com/logo512.png"/>
                <meta name="twitter:card" content="summary_large_image"/>
            </Helmet>
            <section className="home__flex relative">
                {cards}
            </section>
        </main>
    )
}
export default Showreels